export default __webpack_public_path__ + "static/media/mind-aspirant-project.a2977cab.jpeg";